"use client"

import { useCustomNote } from "@lib/hooks/use-custom-note"
import { useEffect } from "react"

export default function CustomNote() {
  const customNote = useCustomNote()

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    customNote.customNoteChange(e.target.value)
  }

  return (
    <div className="flex flex-col items-center justify-start w-full min-h-[8rem] xl:max-w-md max-w-5xl bg-[#FAFAF5] border border-[#E6E6E6] rounded-2xl p-3">
      <h1 className="w-full text-center pb-2 text-lg font-medium border-b border-[#E6E6E6]">
        Poznámka k objednávce
      </h1>
      <h2 className="py-2 text-sm italic font-medium text-center text-gray-500">
        Pokud chcete přidat poznámku, zadejte ji níže:
      </h2>
      <input
        type="text"
        className="w-full max-w-sm p-2 mt-2 text-center border border-gray-300 rounded-2xl"
        placeholder="Poznámka"
        onChange={handleChange}
      />
    </div>
  )
}
